module.exports = __webpack_public_path__ + "static/media/icono factura.817d1643.svg";